import React from 'react';
import MovieCarousel from '../MovieCarousel/MovieCarousel';
import PortraitCarousel from '../PortraitCarousel/PortraitCarousel';
import SquareCarousel from '../SquareCarousel/SquareCarousel';
import CollectionCarousel from '../CollectionCarousel/CollectionCarousel';

const CarouselFactory = ({ section }) => {
    const { title, contents, exhibitionType } = section;

    switch (exhibitionType) {
        case 'portrait':
            return <PortraitCarousel title={title} contents={contents} />;
        case 'square':
            return <SquareCarousel title={title} contents={contents} />;
        case 'grid':
            return <CollectionCarousel title={title} contents={contents} />;
        case 'landscape':
        default:
            return <MovieCarousel title={title} contents={contents} />;
    }
};

export default CarouselFactory; 